import React from 'react';
import { motion } from 'framer-motion';
import styles from './Step.module.scss';

function Step({ number, heading, children, ...other }) {
    return (
        <motion.section className={styles.step} {...other}>
            <p className={styles.stepCount}>Step {number} of 3</p>
            <h2 className={styles.stepHeading}>{heading}</h2>
            {children}
        </motion.section>
    );
}

export default Step;